import React from "react";
import { View, StyleSheet, type StyleProp, type ViewStyle, type DimensionValue } from "react-native";
import { MotiView } from "moti";
import { colors, radii } from "../../../styles/design-system";

export interface SkeletonProps {
  width?: DimensionValue;
  height?: DimensionValue;
  borderRadius?: number;
  style?: StyleProp<ViewStyle>;
}

const Skeleton: React.FC<SkeletonProps> = ({ width = "100%", height = 20, borderRadius = radii.md, style }) => {
  const dynamicStyle: ViewStyle = {
    width,
    height,
    borderRadius,
  };

  return (
    <View style={[styles.container, dynamicStyle, style]}>
      <MotiView
        from={{ translateX: -300 }}
        animate={{ translateX: 300 }}
        // @ts-expect-error - MotiView transition props have complex typing
        transition={{
          type: "timing",
          duration: 1500,
          loop: true,
        }}
        style={styles.shimmerOverlay}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.grey[100],
    overflow: "hidden",
    position: "relative",
  },
  shimmerOverlay: {
    position: "absolute",
    top: 0,
    left: "-50%",
    width: "50%",
    height: "100%",
    backgroundColor: colors.white,
    opacity: 0.6,
    // @ts-expect-error - works for web
    background: `linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent)`,
  },
});

export default Skeleton;
